export type CabDeviceTypeGroup = 'primary' | 'secondary' | 'non_data_bearing';

const KNOWN_GROUPS = new Set<CabDeviceTypeGroup>([
  'primary',
  'secondary',
  'non_data_bearing',
]);

// Mirrors AssettechItemCatalog::NON_DATA_BEARING_ITEMS labels.
const STATIC_NON_DATA_BEARING_LABELS = [
  'TFT Monitors Above 24"',
  'TFT Monitors 24"',
  'TFT Monitors 22"',
  'TFT Monitors 19"',
  'TFT Monitors 17" & all D Grade',
  'CRT Monitors',
  'Printer (Desktop)',
  'Standalone Printer/Photocopier',
  'Interactive Whiteboards',
  'Interactive TVs/Displays',
  'Plasma TV',
  'LCD TV (Below 50")',
  'LCD TV (Above 50")',
  'UPS Battery (Large)',
  'UPS Battery (Medium)',
  'UPS Battery (Small)',
  'UPS Battery (Micro)',
  'Projectors',
  'Cable (Standard Box)',
  'Cable (1/2 Full Builders Bag)',
  'Keyboards & Mouse "K&M"',
  'Small WEEE (10kg)',
  'Large WEEE (25kg)',
];

export function normalizeCabDeviceTypeName(
  value: string | null | undefined
): string {
  return (value ?? '').trim().toLowerCase();
}

const staticNonDataBearingLabels = new Set(
  STATIC_NON_DATA_BEARING_LABELS.map((label) =>
    normalizeCabDeviceTypeName(label)
  )
);

export function cabDeviceTypeGroupsFromRows(
  rows: Array<{ name?: string | null; group?: string | null }>
): Map<string, CabDeviceTypeGroup> {
  const groups = new Map<string, CabDeviceTypeGroup>();

  rows.forEach((row) => {
    const name = normalizeCabDeviceTypeName(row.name);
    const group = (row.group ?? '').trim().toLowerCase();
    if (!name || groups.has(name)) return;
    if (!KNOWN_GROUPS.has(group as CabDeviceTypeGroup)) return;
    groups.set(name, group as CabDeviceTypeGroup);
  });

  return groups;
}

export function isCabNonDataBearing(
  deviceType: string | null | undefined,
  dataBearing: string | null | undefined,
  groupsByName: Map<string, string>
): boolean {
  const name = normalizeCabDeviceTypeName(deviceType);
  const group = name ? groupsByName.get(name) : undefined;
  if (group === 'primary' || group === 'secondary') return false;
  if (group === 'non_data_bearing') return true;
  if (name && staticNonDataBearingLabels.has(name)) return true;
  return dataBearing === 'No';
}
